import { SectionOrServiceForTable } from '../../../types/Admin/CategoriesTopicsTypes';

export const findSectionOrServiceRowById = (
  rows: SectionOrServiceForTable[] | undefined,
  id: number
): SectionOrServiceForTable | undefined => {
  if (!rows?.length) return undefined;

  for (const row of rows) {
    if (row.id === id) return row;
    if (row.subRows?.length) {
      const nested = findSectionOrServiceRowById(row.subRows, id);
      if (nested) return nested;
    }
  }

  return undefined;
};
